import { EntityStore } from './entity-store'

type CustomerGroupsStore = EntityStore<'customerGroups'>

/**
 * Stores information on the retailer's customer groups.
 */
export const customerGroupsStore: CustomerGroupsStore = new EntityStore({
  entityStoreName: 'customerGroups',
  entityName: 'customer_groups',
})
